const initialState = {
    productTypes: [],
    productList: {
        products: [],
        total_count: 0
    },
    productLoading: false,
    productDetails: null,
    productType: null,
    productTags: null,
    productErrorMessage: null,
    showPdtTypes: false,

};

export default function (state = initialState, action) {
    switch (action.type) {


        case 'RESET_PRODUCT': {
            return { ...state, productDetails: null, productType: null, productTags: null, productLoading: true, productErrorMessage: null, preservedTags: null };
        }

        case 'SET_PRODUCT_DETAILS': {
            return {
                ...state,
                productErrorMessage: action.payload.product_error_message,
                productType: action.payload.product_type,
                productDetails: action.payload.product,
                productTags: action.payload.tags,
                preservedTags: action.payload.preserved_tags,
                productLoading: false
            };
        }

        

        case 'SET_PRESERVED_TAGS': {
            return { ...state, preservedTags: action.payload };
        }


        case 'SET_SHOW_PDT_TYPES': {
            return { ...state, showPdtTypes: action.payload };
        }
        case 'SET_PRODUCT_TYPE_TAGS': {
            return { ...state, pdtTypeTags: action.payload };
        }
        case 'RESET_PRODUCT_TYPE_TAGS': {
            return { ...state, pdtTypeTags: null };
        }
        case 'SET_PRODUCT_TAGS': {
            return { ...state, pdtTags: action.payload };
        }
        case 'SET_FILTER': {
            const pdtTags = [...state.productTags];
            const thisTag = pdtTags.find(a => a.parent_tag === action.payload.parent);
            thisTag.selected = action.payload.tags;
            return { ...state, productTags: pdtTags };
        }
        case 'SET_PRODUCT_LIST': {
            return { ...state, productList: action.payload };
        }
        case 'SET_PRODUCT_TYPES': {
            return { ...state, productTypes: action.payload };
        }


        // case 'RESET_PRODUCT_DETAILS': {
        //     console.log('ccccc', action.payload)
        //     return { ...state, productDetails: null };
        // }


        default:
            return state;
    }
}
